import getCookie from './get-cookie';

export const isFlightExpertSiteRunning = request => {
  const BASE_URL = 'flightsexpert.goibibo.com';
  if (request) {
    return (
      request?.headers?.['x-hostname']?.endsWith?.(BASE_URL) ||
      request?.headers?.host?.endsWith?.(BASE_URL)
    );
  }
  if (typeof window !== 'undefined') {
    return window.location.hostname.endsWith(BASE_URL);
  }
};

export const getMCID = () => {
  return getCookie('gi_mcid');
};

export const splitTask = function () {
  return new Promise(resolve => {
    setTimeout(resolve, 0);
  });
};

export const convertDurationToMinutes = timeString => {
  // example: 14h 45m
  // Regular expression to match hours and minutes
  const regex = /(\d+)h\s*(\d+)m/;
  const match = timeString.match(regex);

  if (match) {
    // Extract hours and minutes from the match array
    const hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);

    // Convert hours to minutes and add the minutes
    return hours * 60 + minutes;
  } else {
    throw new Error('Invalid time format. Expected format: "Nh Nm"');
  }
};

export const getABResponse = () => {
  if (typeof window !== 'undefined' && window.AB) {
    return window.AB;
  }

  return {};
};
